<template>
  <svg
    :width="size * (13 / 12)"
    :height="size"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g :clip-path="`url(#clip0_5694_68605)`">
      <path
        d="M9.875 5.22891L9.5 5.25V3.375C9.5 1.51383 7.98617 0 6.125 0C4.26383 0 2.75 1.51383 2.75 3.375V5.25L2.375 5.22891C1.54648 5.22891 0.875 5.90039 0.875 6.72891V10.4789C0.875 11.3072 1.54648 11.9789 2.375 11.9789H9.875C10.7035 11.9789 11.375 11.3072 11.375 10.4789V6.72891C11.375 5.92266 10.7023 5.22891 9.875 5.22891ZM4.25 3.375C4.25 2.34094 5.09141 1.5 6.125 1.5C7.15859 1.5 8 2.34094 8 3.375V5.25H4.25V3.375Z"
        :fill="color"
      />
    </g>
    <defs>
      <clipPath id="clip0_5694_68605">
        <rect width="12" height="12" fill="white" transform="translate(0.125)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#242424',
    },
    size: {
      type: Number,
      default: 12,
    },
  },
};
</script>
